import EducationCategories from "./educationCategories";

export default EducationCategories